import { DownloadIcon } from '../../../../assets/icons/Download';
import { SpreadSheetFileIcon } from '../../../../assets/icons/SpreadSheetFileIcon';
import { downloadFile } from '../../../../utilities/common/download';
import Button from '../../../widgets/Button';
import { Typography } from '../../../widgets/Typography';

const TEMPLATE_URL = '/member-sync-template.csv';
const TEMPLATE_FILE_NAME = 'member-sync-template.csv';
const TEMPLATE_FILE_SIZE = '40 B';

export default function DownloadTemplateCard() {
  return (
    <div className="flex w-2xl flex-col items-start gap-4 rounded-lg border border-taupe-400 bg-white p-6 shadow-md">
      <div className="flex flex-col items-start gap-1">
        <Typography variant="body-lg" weight="semibold">
          Download Template
        </Typography>
        <Typography variant="body-sm" className="text-grey-600 text-pretty">
          To ensure your data is processed correctly, please use our
          standardized CSV template. It includes all required column headers and
          formatting guidelines to help you prepare your data.
        </Typography>
        <div className="border-taupe-550 mt-6 flex w-full flex-row items-center justify-between rounded-xl border bg-taupe-100 p-4">
          <div className="flex flex-row items-center gap-2">
            <div className="border-taupe-550 flex h-full w-16 items-center justify-center rounded-md border bg-white px-2 py-4">
              <SpreadSheetFileIcon className="stroke-green-500" />
            </div>
            <div>
              <Typography variant="body-sm" className="text-grey-900">
                member sync template.csv
              </Typography>
              <Typography variant="body-xs" className="text-grey-700">
                {TEMPLATE_FILE_SIZE}
              </Typography>
            </div>
          </div>
          <Button
            leftIcon={<DownloadIcon />}
            onClick={() => downloadFile(TEMPLATE_URL, TEMPLATE_FILE_NAME)}
          >
            Download
          </Button>
        </div>
      </div>
    </div>
  );
}
